<template>
  <nav
    class="hidden md:block border-b border-gray-200 dark:border-gray-700 bg-white/95 dark:bg-gray-800/95 backdrop-blur-sm sticky top-16 z-30"
    :aria-label="t('portalNav.portalMenu')"
  >
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <ul class="flex flex-wrap gap-1 py-2">
        <li v-for="item in items" :key="item.to">
          <RouterLink
            :to="item.to"
            class="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium transition-colors min-h-[44px]"
            :class="
              isActive(item.to)
                ? 'bg-primary-100 text-primary-800 dark:bg-primary-900/40 dark:text-primary-200'
                : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700/80'
            "
          >
            <i :class="item.icon" aria-hidden="true" />
            {{ item.label }}
          </RouterLink>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const items = computed(() => [
  { label: t('portalNav.payroll'), to: '/portal/payrolls', icon: 'pi pi-wallet' },
  { label: t('portalNav.home'), to: '/portal', icon: 'pi pi-home' },
  { label: t('portalNav.myRequests'), to: '/portal/requests', icon: 'pi pi-inbox' },
  { label: t('portalNav.ppePurchase'), to: '/portal/procurement-requests', icon: 'pi pi-shopping-cart' },
  { label: t('portalNav.myPpe'), to: '/portal/assets', icon: 'pi pi-box' },
  { label: t('portalNav.leaveBalance'), to: '/portal/leave-balance', icon: 'pi pi-calendar' },
  { label: t('portalNav.documents'), to: '/portal/documents', icon: 'pi pi-file' }
])

function isActive(path: string) {
  if (path === '/portal') return route.path === '/portal' || route.path === '/portal/'
  return route.path === path || route.path.startsWith(path + '/')
}
</script>
